<template>
    <AppModal ref="Modal" @on-hide="hide" :title="$t('labels.delete_categories')">
        <div class="modal-body">
            <TaskProgressBar v-if="task.state.isRunning" :done="task.state.done" :total="task.state.total"/>
            <template v-else>
                <p>{{ $t('alerts.delete_categories', { count: categoriesUuids.length }) }}</p>
                <p>{{ $t('alerts.delete_irreversible') }}</p>
                <AppButton class="float-right" color="danger" @click="deleteCategories">
                    {{ $t('buttons.yes') }}
                </AppButton>
                <AppButton class="float-right mr-2" color="light" @click="hide">
                    {{ $t('buttons.no') }}
                </AppButton>
            </template>
        </div>
    </AppModal>
</template>
<script>
import AppModal from '../../../../components/new/modal/AppModal.vue';
import AppButton from '../../../../components/new/button/AppButton.vue';
import TaskProgressBar from '../../../../components/new/progress/TaskProgressBar.vue';

import HttpRequest from '../../../../services/Http/HttpRequest';
import HttpSender from '../../../../services/Http/HttpSender';
import { createProgressTask } from '../../../../services/Progress/ProgressTask';

export default {
    name: "DeleteCategoriesModal",
    components: {
        AppModal, AppButton, TaskProgressBar
    },
    emits : ['categories:deleted'],
    data() {
        return {
            task: createProgressTask(),
            categoriesUuids: []
        }
    },
    methods: {
        show(categoriesUuids) {
            this.categoriesUuids = categoriesUuids;
            this.$refs.Modal.show();
        },
        hide() {
            this.task.cancel();
            this.$refs.Modal.hide();
            this.categoriesUuids = [];
            this.$emit('categories:deleted');
        },
        async deleteCategories() {
            const requests = this.categoriesUuids.map(
                categoryUuid => new HttpRequest('DELETE', `/projects/${this.$route.params.projectUuid}/pim/channels/${this.$route.params.integrationUuid}/categories/${categoryUuid}`),
            );

            const completed = await this.task.run(async ({setTotal, tick}) => {
                setTotal(requests.length);

                await new HttpSender().sendRequestsInBatches(requests, () => tick());
            });

            if (completed) {
                this.hide();
            }
        }
    },
    beforeUnmount() {
        this.task.cancel();
    }
}
</script>
